import React from 'react';

const HIDE_DELAY = 200;

export const useDebouncedVisibility = (hasProductId: boolean) => {
  const [shouldDisplayBottomBar, setShouldDisplayBottomBar] = React.useState(true);

  React.useEffect(() => {
    if (hasProductId) {
      const timer = setTimeout(() => {
        setShouldDisplayBottomBar(false);
      }, HIDE_DELAY);

      return () => clearTimeout(timer);
    }
    setShouldDisplayBottomBar(true);

    return undefined;
  }, [hasProductId]);

  return shouldDisplayBottomBar;
};
